import   React        ,
       { useEffect    }  from 'react';

import   classNames      from 'classnames';

import { X            }  from 'lucide-react';

import   styles          from './ChatModeration.module.scss';

import { ChatModBan   }  from '../../../dataTypes/moderationManagment/chat_types';

/**
 * Les spectateurs bannis par ce créateur. Un bannissement vaut pour toutes ses
 * chaînes et dure jusqu'à ce qu'il soit levé ici. L'adresse IP est masquée par
 * le serveur : elle sert à reconnaître une personne, pas à la localiser.
 */

interface Props {
  bans    : ChatModBan[];
  onLift  : (ban: ChatModBan) => void;
  onClose : () => void;
}

const BansDrawer: React.FC<Props> = ({ bans, onLift, onClose }) => {

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <>
      <div className={styles.drawerBackdrop} onClick={onClose} />
      <aside className={styles.drawer} role="dialog" aria-modal="true" aria-label="Spectateurs bannis">
        <header className={styles.panelHead}>
          <span className={styles.panelTitle}>Spectateurs bannis</span>
          <span className={classNames(styles.count, bans.length === 0 && styles.countZero)}>{bans.length}</span>
          <span className={styles.spacer} />
          <button type="button" className={classNames(styles.btn, styles.btnSmall, styles.btnGhost)} onClick={onClose} aria-label="Fermer" autoFocus>
            <X size={15} />
          </button>
        </header>

        <p className={styles.drawerText}>
          Un spectateur banni ne peut plus écrire dans le chat d'aucune de vos chaînes. Levez le bannissement pour lui rendre la parole.
        </p>

        <div style={{ overflowY: 'auto', flex: 1 }}>
          {bans.length === 0 && <p className={styles.drawerText}>Personne n'est banni.</p>}
          {bans.map(ban => (
            <div key={ban.id} className={styles.banRow}>
              <div className={styles.banWho}>
                <b>{ban.pseudo ?? 'Pseudo inconnu'}</b>
                <span className={styles.muted} style={{ fontSize: 13 }}>
                  {ban.ip}{ban.banDate ? ` · banni le ${new Date(ban.banDate).toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short' })}` : ''}
                </span>
              </div>
              <button type="button" className={classNames(styles.btn, styles.btnSmall)} onClick={() => onLift(ban)}>
                Lever le bannissement
              </button>
            </div>
          ))}
        </div>
      </aside>
    </>
  );
};

export default BansDrawer;
